"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

var _postcssFunctions = _interopRequireDefault(require("postcss-functions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(config) {
  return (0, _postcssFunctions.default)({
    functions: {
      theme: function theme(path) {
        for (var _len = arguments.length, defaultValue = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          defaultValue[_key - 1] = arguments[_key];
        }

        return _lodash.default.thru(_lodash.default.get(config.theme, _lodash.default.trim(path, "'\""), defaultValue), function (value) {
          return Array.isArray(value) ? value.join(', ') : value;
        });
      }
    }
  });
}